
export enum FiltersNumberOperator {

    None = 'None',

    Equal = '=',
    NotEqual = '!=',
    Greater = '>',
    Less = '<',
    GreaterOrEqual = '>=',
    LessOrEqual = '<=',

}

export interface FiltersNumberMethod {
    operator: FiltersNumberOperator;
    value?: number;
}

export class FiltersNumberUtility {

    public static getFilter(method: FiltersNumberMethod) {

        switch (method?.operator) {

            case FiltersNumberOperator.Greater:
                return { $gt: method?.value ?? 0 };

            case FiltersNumberOperator.GreaterOrEqual:
                return { $gte: method?.value ?? 0 }

            case FiltersNumberOperator.Less:
                return { $lt: method?.value ?? 0 }

            case FiltersNumberOperator.LessOrEqual:
                return { $lte: method?.value ?? 0 }

            case FiltersNumberOperator.NotEqual:
                return { $ne: method?.value ?? 0 }

            default:
                return method?.value;

        }

    }

    public static getLabel(method: FiltersNumberMethod) {

        // null/undefined check instead of !! so that 0 renders as a chip label ("= 0", "> 0", etc.).
        if (method?.value == null) return null;

        switch (method?.operator) {

            case FiltersNumberOperator.Greater:
                return `> ${method?.value}`;

            case FiltersNumberOperator.GreaterOrEqual:
                return `>= ${method?.value}`;

            case FiltersNumberOperator.Less:
                return `< ${method?.value}`;

            case FiltersNumberOperator.LessOrEqual:
                return `<= ${method?.value}`;

            case FiltersNumberOperator.NotEqual:
                return `!= ${method?.value}`;

            default:
                return `= ${method?.value}`;

        }

    }

}